(function () {
  "use strict";

  var INIT_ATTR = "data-ecomato-cpf-bound";

  function getOrdinalNum(n) {
    return (
      n +
      (n > 0
        ? ["th", "st", "nd", "rd"][(n > 3 && n < 21) || n % 10 > 3 ? 0 : n % 10]
        : "")
    );
  }

  function formatShipDate(date) {
    var days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    var months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return (
      days[date.getDay()] +
      ", " +
      months[date.getMonth()] +
      " " +
      getOrdinalNum(date.getDate())
    );
  }

  function formatMoney(cents, shopMoneyFormat) {
    if (typeof cents !== "number") cents = parseInt(cents, 10);
    var value = (cents / 100).toFixed(2);
    return shopMoneyFormat.replace(
      /\{\{\s*amount\s*\}\}|\{\{\s*amount_with_comma_separator\s*\}\}/g,
      value,
    );
  }

  function readJsonScript(sectionRoot, selector) {
    var node = sectionRoot.querySelector(selector);
    if (!node || !node.textContent) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (_err) {
      return null;
    }
  }

  function initCustomProductFocusSection(sectionRoot) {
    if (!sectionRoot || sectionRoot.getAttribute(INIT_ATTR) === "true") return;
    sectionRoot.setAttribute(INIT_ATTR, "true");

    // Warmly v2 Product Info: place ATC beside quantity when both blocks exist.
    var commerceSlot = sectionRoot.querySelector("[data-cp-buy-actions-slot]");
    var buyButtonsBlock = sectionRoot.querySelector("[data-cp-buy-buttons]");
    if (commerceSlot && buyButtonsBlock) {
      var atcBtn = buyButtonsBlock.querySelector(".cp-buy-btn");
      if (atcBtn) commerceSlot.appendChild(atcBtn);
    }

    var productData = readJsonScript(sectionRoot, "[data-ecomato-cpf-product]");
    var shopMoneyFormat =
      readJsonScript(sectionRoot, "[data-ecomato-cpf-money-format]") ||
      "${{amount}}";
    if (!productData || !productData.variants) return;

    var form = sectionRoot.querySelector(".custom-product-form");
    if (!form) return;

    var cartAction = sectionRoot.getAttribute("data-cart-action") || "ajax";
    var variantRadios = sectionRoot.querySelectorAll(".dynamic-variant-trigger");
    var bundleRadios = sectionRoot.querySelectorAll(".bundle-trigger");
    var qtyInput =
      sectionRoot.querySelector(".cp-qty-input") ||
      sectionRoot.querySelector(".cp-hidden-quantity");
    var minusBtn = sectionRoot.querySelector(".cp-qty-minus");
    var plusBtn = sectionRoot.querySelector(".cp-qty-plus");
    var addToCartBtn = sectionRoot.querySelector(".cp-buy-btn");
    var buyNowBtn = sectionRoot.querySelector(".cp-buy-now-btn");
    var mainSoldOutTag = sectionRoot.querySelector(".cp-main-sold-out-tag");
    var hiddenVariantId = sectionRoot.querySelector(".cp-hidden-variant-id");
    var mainImage = sectionRoot.querySelector(".cp-main-image-img");
    var thumbnails = sectionRoot.querySelectorAll(".cp-thumb");
    var thumbCarousel = sectionRoot.querySelector(".cp-thumb-carousel");
    var thumbsViewport = sectionRoot.querySelector(".cp-thumbs-viewport");
    var thumbsTrack = sectionRoot.querySelector(".cp-thumbs-track");
    var thumbPrevNav = sectionRoot.querySelector(".cp-thumb-nav--prev");
    var thumbNextNav = sectionRoot.querySelector(".cp-thumb-nav--next");
    var THUMB_SIZE = 72;
    var THUMB_GAP = 12;
    var THUMB_STRIDE = THUMB_SIZE + THUMB_GAP;
    var THUMB_MOBILE_MAX = 749;
    var thumbScrollStart = 0;

    function isThumbMobileLayout() {
      return (
        typeof window !== "undefined" &&
        window.matchMedia &&
        window.matchMedia("(max-width: " + THUMB_MOBILE_MAX + "px)").matches
      );
    }

    function visibleThumbCount(viewportWidth) {
      if (!(viewportWidth > 0)) return 1;
      return Math.max(1, Math.floor((viewportWidth + THUMB_GAP) / THUMB_STRIDE));
    }

    function maxThumbScrollStart(count, visible) {
      return Math.max(0, count - Math.max(1, visible));
    }

    function getActiveThumbIndex() {
      for (var i = 0; i < thumbnails.length; i += 1) {
        if (thumbnails[i].classList.contains("active")) return i;
      }
      return 0;
    }

    function syncThumbCarouselUi() {
      if (!thumbCarousel || !thumbsViewport || !thumbsTrack) return;
      var count = thumbnails.length;
      var mobile = isThumbMobileLayout();
      var visible = visibleThumbCount(thumbsViewport.clientWidth);
      var needsCarousel = count > visible;
      var activeIndex = getActiveThumbIndex();

      thumbCarousel.setAttribute("data-layout", mobile ? "mobile" : "desktop");
      thumbCarousel.setAttribute(
        "data-carousel",
        needsCarousel ? "true" : "false",
      );

      if (mobile || !needsCarousel) {
        thumbScrollStart = 0;
        thumbsTrack.style.transform = "";
      } else {
        var maxStart = maxThumbScrollStart(count, visible);
        if (activeIndex < thumbScrollStart) thumbScrollStart = activeIndex;
        if (activeIndex >= thumbScrollStart + visible) {
          thumbScrollStart = Math.min(maxStart, activeIndex - visible + 1);
        }
        thumbScrollStart = Math.max(0, Math.min(maxStart, thumbScrollStart));
        thumbsTrack.style.transform =
          "translateX(" + -(thumbScrollStart * THUMB_STRIDE) + "px)";
      }

      if (thumbPrevNav) {
        thumbPrevNav.hidden = mobile || !needsCarousel;
        thumbPrevNav.disabled = activeIndex <= 0;
      }
      if (thumbNextNav) {
        thumbNextNav.hidden = mobile || !needsCarousel;
        thumbNextNav.disabled = activeIndex >= count - 1;
      }

      if (mobile && thumbnails[activeIndex]) {
        thumbnails[activeIndex].scrollIntoView({
          behavior: "smooth",
          inline: "nearest",
          block: "nearest",
        });
      }
    }

    function selectThumbAt(index) {
      if (index < 0 || index >= thumbnails.length) return;
      var thumb = thumbnails[index];
      if (!thumb) return;
      thumbnails.forEach(function (t) {
        t.classList.remove("active");
        t.setAttribute("aria-pressed", "false");
      });
      thumb.classList.add("active");
      thumb.setAttribute("aria-pressed", "true");
      if (mainImage) {
        mainImage.src = thumb.getAttribute("data-full-image") || mainImage.src;
      }
      syncThumbCarouselUi();
      syncMainNavUi();
    }

    sectionRoot.querySelectorAll(".cp-block[data-min-days]").forEach(function (block) {
      var minDays = parseInt(block.getAttribute("data-min-days") || "0", 10);
      var maxDays = parseInt(block.getAttribute("data-max-days") || "0", 10);
      if (!Number.isFinite(minDays) || minDays < 0) minDays = 0;
      if (!Number.isFinite(maxDays) || maxDays < 0) maxDays = 0;
      if (minDays > maxDays) maxDays = minDays;
      var today = new Date();
      var maxDate = new Date(today);
      maxDate.setDate(today.getDate() + maxDays);
      var byWrap = block.querySelector(".cp-ship-by-wrap");
      var betweenWrap = block.querySelector(".cp-ship-between-wrap");
      var byEl = block.querySelector(".cp-ship-by");
      var minEl = block.querySelector(".cp-ship-min");
      var maxEl = block.querySelector(".cp-ship-max");
      // minDays === 0 → "Get it by [max]"; minDays > 0 → "Get it between [min] and [max]"
      if (minDays === 0) {
        if (byWrap) byWrap.hidden = false;
        if (betweenWrap) betweenWrap.hidden = true;
        if (byEl) byEl.textContent = formatShipDate(maxDate);
      } else {
        var minDate = new Date(today);
        minDate.setDate(today.getDate() + minDays);
        if (byWrap) byWrap.hidden = true;
        if (betweenWrap) betweenWrap.hidden = false;
        if (minEl) minEl.textContent = formatShipDate(minDate);
        if (maxEl) maxEl.textContent = formatShipDate(maxDate);
      }
    });

    thumbnails.forEach(function (thumb, index) {
      thumb.addEventListener("click", function () {
        selectThumbAt(index);
      });
    });

    if (thumbPrevNav) {
      thumbPrevNav.addEventListener("click", function () {
        selectThumbAt(getActiveThumbIndex() - 1);
      });
    }
    if (thumbNextNav) {
      thumbNextNav.addEventListener("click", function () {
        selectThumbAt(getActiveThumbIndex() + 1);
      });
    }

    var mainStage = sectionRoot.querySelector("[data-cp-main-stage]");
    var mainPrevNav = sectionRoot.querySelector('[data-cp-main-nav="prev"]');
    var mainNextNav = sectionRoot.querySelector('[data-cp-main-nav="next"]');

    function syncMainNavUi() {
      var index = getActiveThumbIndex();
      var count = thumbnails.length;
      if (mainPrevNav) mainPrevNav.disabled = index <= 0 || count < 2;
      if (mainNextNav) mainNextNav.disabled = index >= count - 1 || count < 2;
    }

    if (mainPrevNav) {
      mainPrevNav.addEventListener("click", function (event) {
        event.preventDefault();
        selectThumbAt(getActiveThumbIndex() - 1);
      });
    }
    if (mainNextNav) {
      mainNextNav.addEventListener("click", function (event) {
        event.preventDefault();
        selectThumbAt(getActiveThumbIndex() + 1);
      });
    }

    // Swipe left/right on the main image (mobile gallery).
    if (mainStage && thumbnails.length > 1) {
      var swipeStartX = null;
      var swipeStartY = null;
      var swipeLocked = false;
      mainStage.addEventListener(
        "touchstart",
        function (event) {
          if (!event.touches || event.touches.length !== 1) return;
          swipeStartX = event.touches[0].clientX;
          swipeStartY = event.touches[0].clientY;
          swipeLocked = false;
        },
        { passive: true },
      );
      mainStage.addEventListener(
        "touchmove",
        function (event) {
          if (swipeStartX == null || !event.touches || !event.touches.length) {
            return;
          }
          var dx = event.touches[0].clientX - swipeStartX;
          var dy = event.touches[0].clientY - swipeStartY;
          if (!swipeLocked && Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy)) {
            swipeLocked = true;
          }
          if (swipeLocked && event.cancelable) event.preventDefault();
        },
        { passive: false },
      );
      mainStage.addEventListener(
        "touchend",
        function (event) {
          if (swipeStartX == null) return;
          var touch = event.changedTouches && event.changedTouches[0];
          var endX = touch ? touch.clientX : swipeStartX;
          var delta = endX - swipeStartX;
          swipeStartX = null;
          swipeStartY = null;
          if (!swipeLocked || Math.abs(delta) < 40) return;
          if (delta < 0) selectThumbAt(getActiveThumbIndex() + 1);
          else selectThumbAt(getActiveThumbIndex() - 1);
        },
        { passive: true },
      );
    }

    syncMainNavUi();

    if (typeof ResizeObserver !== "undefined" && thumbsViewport) {
      var thumbResizeObserver = new ResizeObserver(function () {
        syncThumbCarouselUi();
      });
      thumbResizeObserver.observe(thumbsViewport);
    }
    if (typeof window !== "undefined" && window.matchMedia) {
      var thumbMedia = window.matchMedia(
        "(max-width: " + THUMB_MOBILE_MAX + "px)",
      );
      var onThumbMedia = function () {
        syncThumbCarouselUi();
      };
      if (typeof thumbMedia.addEventListener === "function") {
        thumbMedia.addEventListener("change", onThumbMedia);
      } else if (typeof thumbMedia.addListener === "function") {
        thumbMedia.addListener(onThumbMedia);
      }
    }
    syncThumbCarouselUi();

    function syncBundleWithQty() {
      if (!qtyInput) return;
      var val = qtyInput.value;
      var match = sectionRoot.querySelector(
        '.bundle-trigger[data-qty="' + val + '"]',
      );
      if (match) {
        match.checked = true;
      } else {
        bundleRadios.forEach(function (r) {
          r.checked = false;
        });
      }
    }

    if (minusBtn && plusBtn && qtyInput) {
      minusBtn.addEventListener("click", function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        if (val > 1) {
          qtyInput.value = String(val - 1);
          syncBundleWithQty();
        }
      });
      plusBtn.addEventListener("click", function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = String(val + 1);
        syncBundleWithQty();
      });
      qtyInput.addEventListener("change", syncBundleWithQty);
    }

    function onBundleChange() {
      var activeBundle = sectionRoot.querySelector(".bundle-trigger:checked");
      if (activeBundle && qtyInput) {
        qtyInput.value = activeBundle.getAttribute("data-qty") || "1";
      }
    }
    bundleRadios.forEach(function (radio) {
      radio.addEventListener("change", onBundleChange);
    });

    function updateBundlePrices(variantPriceInCents) {
      bundleRadios.forEach(function (trigger) {
        var qty = parseInt(trigger.getAttribute("data-qty") || "1", 10);
        var discountStr = trigger.getAttribute("data-discount");
        var discountPct = discountStr ? parseFloat(discountStr) / 100 : 0;
        var totalCents = variantPriceInCents * qty * (1 - discountPct);
        var unitCents = totalCents / qty;
        var label = trigger.nextElementSibling;
        if (!label) return;
        var unitEl = label.querySelector(".bundle-unit-display");
        var totalEl = label.querySelector(".bundle-total-display");
        var compareEl = label.querySelector(".bundle-compare-display");
        if (unitEl) unitEl.innerHTML = formatMoney(unitCents, shopMoneyFormat);
        if (totalEl) totalEl.innerHTML = formatMoney(totalCents, shopMoneyFormat);
        if (compareEl && qty > 1 && discountPct > 0) {
          compareEl.innerHTML = formatMoney(
            variantPriceInCents * qty,
            shopMoneyFormat,
          );
        }
      });
    }

    function updateOptionAvailability() {
      var selectedOptions = Array.from(
        sectionRoot.querySelectorAll(".dynamic-variant-trigger:checked"),
      ).map(function (el) {
        return el.value;
      });

      variantRadios.forEach(function (radio) {
        var group = radio.closest(".cp-option-group");
        if (!group) return;
        var groupIndex = parseInt(
          group.getAttribute("data-option-index") || "0",
          10,
        );
        var hypotheticalOptions = selectedOptions.slice();
        hypotheticalOptions[groupIndex] = radio.value;
        var matchedVariant = productData.variants.find(function (v) {
          return v.options.every(function (opt, i) {
            return opt === hypotheticalOptions[i];
          });
        });
        var label = sectionRoot.querySelector('label[for="' + radio.id + '"]');
        if (!label) return;
        if (matchedVariant && matchedVariant.available) {
          label.classList.remove("is-sold-out");
        } else {
          label.classList.add("is-sold-out");
        }
      });
    }

    function onVariantChange(clickedRadio) {
      if (clickedRadio) {
        var group = clickedRadio.closest(".cp-option-group");
        if (group) {
          var valueText = group.querySelector(".cp-selected-value-text");
          if (valueText) valueText.textContent = clickedRadio.value;
        }
      }

      updateOptionAvailability();

      var selectedOptions = Array.from(
        sectionRoot.querySelectorAll(".dynamic-variant-trigger:checked"),
      ).map(function (el) {
        return el.value;
      });
      var matchedVariant = productData.variants.find(function (variant) {
        return variant.options.every(function (opt, index) {
          return opt === selectedOptions[index];
        });
      });

      if (!matchedVariant) return;

      if (hiddenVariantId) hiddenVariantId.value = String(matchedVariant.id);

      if (matchedVariant.available) {
        if (addToCartBtn) {
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = "ADD TO CART";
        }
        if (buyNowBtn) buyNowBtn.disabled = false;
        if (mainSoldOutTag) mainSoldOutTag.classList.remove("active");
      } else {
        if (addToCartBtn) {
          addToCartBtn.disabled = true;
          addToCartBtn.textContent = "SOLD OUT";
        }
        if (buyNowBtn) buyNowBtn.disabled = true;
        if (mainSoldOutTag) mainSoldOutTag.classList.add("active");
      }

      if (matchedVariant.featured_image) {
        var imageId = matchedVariant.featured_image.id;
        var targetThumb = sectionRoot.querySelector(
          '.cp-thumb[data-image-id="' + imageId + '"]',
        );
        if (targetThumb) {
          var targetIndex = Array.prototype.indexOf.call(thumbnails, targetThumb);
          if (targetIndex >= 0) selectThumbAt(targetIndex);
          else targetThumb.click();
        } else if (mainImage && matchedVariant.featured_image.src) {
          mainImage.src = matchedVariant.featured_image.src;
        }
      }

      var mainPriceEl = sectionRoot.querySelector(".cp-main-price");
      var priceWrapper = sectionRoot.querySelector(".cp-price-wrapper");
      var mainCompareEl = sectionRoot.querySelector(".cp-main-compare");
      var mainSaveTag = sectionRoot.querySelector(".cp-main-save-tag");

      if (mainPriceEl) {
        mainPriceEl.innerHTML = formatMoney(matchedVariant.price, shopMoneyFormat);
      }

      function ensureCompareEl() {
        if (mainCompareEl) return mainCompareEl;
        if (!priceWrapper || !mainPriceEl) return null;
        mainCompareEl = document.createElement("span");
        mainCompareEl.className = "cp-price-compare cp-main-compare";
        priceWrapper.insertBefore(mainCompareEl, mainPriceEl);
        return mainCompareEl;
      }

      function ensureSaveTag() {
        mainSaveTag = sectionRoot.querySelector(".cp-main-save-tag");
        if (mainSaveTag) return mainSaveTag;
        if (!priceWrapper) return null;
        var compare = ensureCompareEl();
        mainSaveTag = document.createElement("span");
        mainSaveTag.className = "cp-save-tag cp-main-save-tag active";
        if (compare) priceWrapper.insertBefore(mainSaveTag, compare);
        else if (mainPriceEl) priceWrapper.insertBefore(mainSaveTag, mainPriceEl);
        else priceWrapper.appendChild(mainSaveTag);
        return mainSaveTag;
      }

      function clearDiscountUi() {
        if (mainCompareEl) {
          mainCompareEl.innerHTML = "";
          mainCompareEl.hidden = true;
        }
        mainSaveTag = sectionRoot.querySelector(".cp-main-save-tag");
        if (mainSaveTag) mainSaveTag.remove();
      }

      if (
        matchedVariant.compare_at_price > matchedVariant.price &&
        matchedVariant.compare_at_price > 0
      ) {
        var savePct = Math.round(
          ((matchedVariant.compare_at_price - matchedVariant.price) /
            matchedVariant.compare_at_price) *
            100,
        );
        if (savePct > 0) {
          var compareEl = ensureCompareEl();
          if (compareEl) {
            compareEl.hidden = false;
            compareEl.innerHTML = formatMoney(
              matchedVariant.compare_at_price,
              shopMoneyFormat,
            );
          }
          var saveTag = ensureSaveTag();
          if (saveTag) {
            saveTag.textContent = savePct + "% OFF";
            saveTag.classList.add("active");
            saveTag.hidden = false;
          }
        } else {
          clearDiscountUi();
        }
      } else {
        clearDiscountUi();
      }

      updateBundlePrices(matchedVariant.price);

      var availabilityEl = sectionRoot.querySelector("[data-cp-availability]");
      if (availabilityEl) {
        if (!matchedVariant.available) {
          availabilityEl.textContent = "Availability: Sold out";
        } else if (
          matchedVariant.inventory_management &&
          typeof matchedVariant.inventory_quantity === "number" &&
          matchedVariant.inventory_quantity > 0 &&
          matchedVariant.inventory_quantity <= 10
        ) {
          availabilityEl.textContent =
            matchedVariant.inventory_quantity === 1
              ? "Availability: Only 1 left!"
              : "Availability: Only " +
                matchedVariant.inventory_quantity +
                " left!";
        } else {
          availabilityEl.textContent = "Availability: In stock";
        }
      }
    }

    variantRadios.forEach(function (radio) {
      radio.addEventListener("change", function () {
        onVariantChange(radio);
      });
    });

    updateOptionAvailability();

    if (buyNowBtn && form) {
      buyNowBtn.addEventListener("click", function () {
        if (buyNowBtn.disabled) return;
        if (!form.querySelector('input[name="return_to"]')) {
          form.insertAdjacentHTML(
            "beforeend",
            '<input type="hidden" name="return_to" value="/checkout">',
          );
        }
        form.submit();
      });
    }

    if (cartAction === "ajax") {
      form.addEventListener("submit", function (e) {
        if (e.submitter && e.submitter.classList.contains("cp-buy-now-btn")) {
          return;
        }
        e.preventDefault();

        if (addToCartBtn) {
          addToCartBtn.classList.add("loading");
          addToCartBtn.textContent = "ADDING...";
        }

        var formData = new FormData(form);
        var cartUi =
          document.querySelector("cart-drawer") ||
          document.querySelector("cart-notification");
        var sections = [];
        if (cartUi && typeof cartUi.getSectionsToRender === "function") {
          try {
            sections = (cartUi.getSectionsToRender() || [])
              .map(function (ref) {
                return (ref && (ref.id || ref.section)) || "";
              })
              .map(function (id) {
                return String(id).trim();
              })
              .filter(Boolean);
          } catch (_err) {
            sections = [];
          }
        }
        if (!sections.length) {
          if (document.querySelector("cart-drawer")) sections.push("cart-drawer");
          if (document.querySelector("cart-notification")) {
            sections.push("cart-notification");
          }
          if (document.querySelector("cart-icon-bubble")) {
            sections.push("cart-icon-bubble");
          }
        }
        if (sections.length > 0) {
          formData.append("sections", sections.join(","));
          formData.append("sections_url", window.location.pathname);
        }

        var shopifyRoot =
          (window.Shopify &&
            window.Shopify.routes &&
            window.Shopify.routes.root) ||
          "/";
        var cartUrl =
          (window.routes && window.routes.cart_url) || shopifyRoot + "cart";

        function openEcomatoCartDrawer() {
          var root = document.querySelector("[data-ecomato-cart-drawer]");
          if (!root) return false;
          var drawer = root._ecomatoCartDrawer;
          try {
            if (drawer && typeof drawer.show === "function") {
              // Open with skeleton immediately, then refresh cart lines.
              drawer.show({ loading: true, skipRefresh: true });
              if (typeof drawer.refresh === "function") drawer.refresh();
              return true;
            }
            document.dispatchEvent(new CustomEvent("ecomato:cart:open"));
            return true;
          } catch (_err) {
            return false;
          }
        }

        function openThemeCartUi(ui) {
          if (!ui) return;
          try {
            if (ui.classList && ui.classList.contains("is-empty")) {
              ui.classList.remove("is-empty");
            }
            if (typeof ui.open === "function") ui.open();
          } catch (_err) {
            /* theme open is best-effort after a successful add */
          }
        }

        function publishThemeCartEvents(data) {
          try {
            document.documentElement.dispatchEvent(
              new CustomEvent("cart:refresh", { bubbles: true }),
            );
          } catch (_err) {
            /* ignore */
          }
          try {
            document.dispatchEvent(
              new CustomEvent("ajaxProduct:added", {
                bubbles: true,
                detail: { product: data },
              }),
            );
          } catch (_err) {
            /* ignore */
          }
          try {
            if (
              typeof window.publish === "function" &&
              window.PUB_SUB_EVENTS &&
              window.PUB_SUB_EVENTS.cartUpdate
            ) {
              window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
                source: "ecomato-custom-product-focus",
                cartData: data,
              });
            }
          } catch (_err) {
            /* ignore */
          }
        }

        /**
         * Dawn CartItems-style refresh: replace drawer body/footer from live
         * cart section HTML so line items appear without a full page reload.
         * Re-query cart UI after replacement — do not keep stale refs.
         */
        function refreshCartDrawerFromSection() {
          var sectionId = "cart-drawer";
          var liveUi =
            document.querySelector("cart-drawer") ||
            document.querySelector("cart-notification");
          if (liveUi && typeof liveUi.getSectionsToRender === "function") {
            try {
              var first = (liveUi.getSectionsToRender() || [])[0];
              if (first && (first.section || first.id)) {
                sectionId = String(first.section || first.id);
              }
            } catch (_err) {
              /* keep default */
            }
          }

          return fetch(cartUrl + "?section_id=" + encodeURIComponent(sectionId))
            .then(function (res) {
              return res.text();
            })
            .then(function (responseText) {
              var html = new DOMParser().parseFromString(
                responseText,
                "text/html",
              );
              [
                "cart-drawer-items",
                ".cart-drawer__footer",
                "#CartDrawer-CartItems",
              ].forEach(function (selector) {
                var target = document.querySelector(selector);
                var source = html.querySelector(selector);
                if (target && source) target.replaceWith(source);
              });

              var liveDrawer = document.querySelector("cart-drawer");
              var sourceDrawer = html.querySelector("cart-drawer");
              if (
                liveDrawer &&
                sourceDrawer &&
                !document.querySelector("cart-drawer-items")
              ) {
                var liveInner =
                  liveDrawer.querySelector(".drawer__inner") || liveDrawer;
                var sourceInner =
                  sourceDrawer.querySelector(".drawer__inner") || sourceDrawer;
                if (liveInner && sourceInner) {
                  liveInner.innerHTML = sourceInner.innerHTML;
                }
              }

              return fetch(shopifyRoot + "?sections=cart-icon-bubble")
                .then(function (iconRes) {
                  return iconRes.json();
                })
                .then(function (sectionsPayload) {
                  if (
                    !sectionsPayload ||
                    !sectionsPayload["cart-icon-bubble"]
                  ) {
                    return;
                  }
                  var iconHtml = new DOMParser().parseFromString(
                    sectionsPayload["cart-icon-bubble"],
                    "text/html",
                  );
                  var iconTarget = document.getElementById("cart-icon-bubble");
                  var iconSource =
                    iconHtml.getElementById("cart-icon-bubble") ||
                    iconHtml.querySelector("#cart-icon-bubble");
                  if (iconTarget && iconSource) {
                    iconTarget.innerHTML = iconSource.innerHTML;
                  }
                })
                .catch(function () {
                  /* icon bubble is optional */
                });
            });
        }

        function refreshAndOpenCartUi(data) {
          var ui =
            document.querySelector("cart-drawer") ||
            document.querySelector("cart-notification");

          var rendered = false;
          if (
            ui &&
            typeof ui.renderContents === "function" &&
            data &&
            data.sections &&
            typeof data.sections === "object"
          ) {
            try {
              if (ui.classList && ui.classList.contains("is-empty")) {
                ui.classList.remove("is-empty");
              }
              ui.renderContents(data);
              rendered = true;
            } catch (_err) {
              rendered = false;
            }
          }

          if (rendered) {
            // Dawn renderContents already opens; re-open if still closed.
            openThemeCartUi(
              document.querySelector("cart-drawer") ||
                document.querySelector("cart-notification"),
            );
            publishThemeCartEvents(data);
            return Promise.resolve();
          }

          publishThemeCartEvents(data);
          return refreshCartDrawerFromSection()
            .catch(function () {})
            .then(function () {
              openThemeCartUi(
                document.querySelector("cart-drawer") ||
                  document.querySelector("cart-notification"),
              );
            });
        }

        fetch(shopifyRoot + "cart/add.js", {
          method: "POST",
          body: formData,
        })
          .then(function (res) {
            return res.json().then(function (data) {
              var addFailed =
                !res.ok ||
                (data &&
                  typeof data.status === "number" &&
                  data.status >= 400) ||
                (data && data.errors);
              if (addFailed) {
                var err = new Error(
                  (data && (data.description || data.message)) ||
                    "cart_add_failed",
                );
                err.cartAddFailed = true;
                throw err;
              }
              return data;
            });
          })
          .then(function (data) {
            if (addToCartBtn) {
              addToCartBtn.classList.remove("loading");
              addToCartBtn.textContent = "ADDED!";
            }

            // Prefer Ecomato Warmly cart drawer when present (faster + no empty flash).
            if (typeof openEcomatoCartDrawer === "function" && openEcomatoCartDrawer()) {
              try {
                document.dispatchEvent(new CustomEvent("ecomato:cart:refresh"));
              } catch (_err) {}
              setTimeout(function () {
                if (addToCartBtn) addToCartBtn.textContent = "ADD TO CART";
              }, 2000);
              return;
            }

            // Add already succeeded — never surface ERROR for drawer refresh/open.
            return refreshAndOpenCartUi(data)
              .catch(function () {})
              .finally(function () {
                setTimeout(function () {
                  if (addToCartBtn) addToCartBtn.textContent = "ADD TO CART";
                }, 2000);
              });
          })
          .catch(function () {
            if (addToCartBtn) {
              addToCartBtn.classList.remove("loading");
              addToCartBtn.textContent = "ERROR";
            }
          });
      });
    }
  }

  function boot(scope) {
    var root = scope && scope.querySelector ? scope : document;
    root
      .querySelectorAll(
        '[data-ecomato-section="custom-product-focus"]:not([' + INIT_ATTR + "])",
      )
      .forEach(initCustomProductFocusSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (event.target) boot(event.target);
  });
})();
